const PRIVACY_INFOGRAPHIC_FILENAME = "LiveSwitch_Data_Privacy.png";

export function downloadDataPrivacyInfographic(): void {
	const anchor = document.createElement("a");
	anchor.href = `/${PRIVACY_INFOGRAPHIC_FILENAME}`;
	anchor.download = PRIVACY_INFOGRAPHIC_FILENAME;
	document.body.appendChild(anchor);
	anchor.click();
	anchor.remove();
}
